import React from 'react';
import '../hero.css';
import './imageRightTextBanner.css';
import { Label, Badge, Video } from '@nooz-optics/nooz-components-lib';
import { BannerProps } from './index';
import { Image } from '../../../UI/Media/Image';
import { Slider } from '../../../UI/Navigation/Slider/slider';
import { formatContentfulComponentProps } from '../../../../utils/globals';
import { TextBanner } from '../BannerText/bannerText';
import { Grid } from '../../../UI/Grid/grid';
import { BannerButtons } from '../BannerButtons/bannerButtons';
import { ImageTextBanner } from '../imageTextBanner';

export const ImageRightTextMediumBanner = ({
  label,
  body,
  desktopImage,
  buttons,
  image,
}: BannerProps) => (
  <div
    style={{ backgroundColor: desktopImage.bgColor }}
    id='image-right-text-medium-hero-'
    className='flex overflow-hidden flex-col-reverse lg:flex-row w-screen h-auto min-h-screen-2/3 md:min-h-screen-1/2 justify-center items-center relative'
  >
    <div className='flex items-end h-full w-full md:absolute'>
      <div className='absolute md:hidden inset-0'>
        <Image objectFit='cover' {...image} height='100%' width='100%' />
      </div>
      <div className='md:w-9/12 lg:w-2/3 xl:w-1/2 h-full hidden md:flex'>
        <Image {...desktopImage} height='100%' />
      </div>
    </div>
    <TextBanner placement='right' body={body} label={label} buttons={buttons} />
  </div>
);

export const HomeSliderBanner = ({ slides }: BannerProps) => (
  <>
    <div className='block w-full mb-10 md:hidden'>
      <Grid
        grid={{
          isSlider: 'block',
          space: 'space-x-5',
          itemsWidth:
            'min-w-10/12 md:w-1/2 md:min-w-5/12 xl:w-1/4 xl:min-w-1/4',
          gridItems: slides.items.map((slide) => {
            const { image, label, video, buttons, badges, subLabel } = {
              ...formatContentfulComponentProps(slide),
            };
            return (
              <div className='overflow-hidden border w-full'>
                <div
                  id='hero-main'
                  className='hero-main rounded-xl image-right-text-slide-item flex flex-col justify-between h-full relative'
                >
                  <div className='absolute -z-1 h-full w-full'>
                    {image && (
                      <Image
                        {...image}
                        objectFit='cover'
                        height='100%'
                        width='100%'
                      />
                    )}

                    {video && <Video {...video} height='100%' width='100%' />}
                  </div>
                  <div className='w-full p-6'>
                    <div className='mb-4 flex w-11/12'>
                      {badges?.items.map((badge) => (
                        <div className='mr-2'>
                          <Badge {...badge} />
                        </div>
                      ))}
                    </div>
                    <div className='mb-4 w-11/12'>
                      <Label
                        {...label}
                        size='4xl'
                        weight='medium'
                        color={label?.color || { classname: 'white' }}
                      />
                      {subLabel && (
                        <Label
                          {...subLabel}
                          size='4xl'
                          weight='medium'
                          color={subLabel?.color || { classname: 'white' }}
                        />
                      )}
                    </div>
                  </div>
                  <div className='w-full p-6 flex justify-center'>
                    <BannerButtons buttons={buttons} size='lg' />
                  </div>
                </div>
              </div>
            );
          }),
        }}
      />
    </div>
    <div className='hidden md:block hero-main-slider w-screen'>
      <Slider
        hasAutoPlay
        hasDots
        centerMode
        pauseOnHover={false}
        autoplaySpeed={5000}
        centerPadding={0}
        slidesToShow={1}
        isInfinite
      >
        {slides.items.map((item) => {
          const slide = formatContentfulComponentProps(item);
          return <ImageTextBanner {...slide} />;
        })}
      </Slider>
    </div>
  </>
);
